import React from 'react'
import Tick from "../../assets/images/public-pages/tick-circle-green.svg";
import ButtonComp from './ButtonComp';

const NaatiCourseCards = ({ skillAreaTitle, btnText, cards = [], btnLink }) => {
  return (
  <div className='new-design'>
    <div className="naati-course-cards-section py-5">
      <style>
        {`
          .naati-course-cards-section .card-wrapper {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            align-items: stretch;
            gap: 24px;
           /* Space for the "MOST POPULAR" badge */
          }
          .naati-course-cards-section .naati-card {
            flex: 1;
            min-width: 280px; /* Allows flexibility while maintaining a readable min-width */
            border-radius: 24px;
            padding: 40px 32px;
            display: flex;
            flex-direction: column;
            gap: 24px;
            position: relative;
            border: 1px solid #182A4F1F;
            height: auto;
            box-sizing: border-box;
          }
          .naati-course-cards-section .naati-card.popular {
            background: #FFFFFF;
            border: 2px solid #9FD94B;
          }
          .naati-course-cards-section .popular-badge {
            position: absolute;
            top: -18px;
            left: 50%;
            transform: translateX(-50%);
            background: #9FD94B;
            color: white;
            padding: 4px 16px;
            border-radius: 12px;
            font-size: 14px;
            font-weight: 600;
            white-space: nowrap;
          }
          .naati-course-cards-section .card-title {
             /* Shared styles for title if needed, but using user's classes now */
          }
           .naati-course-cards-section .large {
            font-size: 22px !important;
          }
          .naati-course-cards-section .feature-list-new {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            gap: 16px;
          }
          .naati-course-cards-section .feature-item-new {
            display: flex;
            gap: 12px;
            align-items: flex-start;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.5;
            font-family: 'Plus Jakarta Sans', sans-serif;
            
          }
          .naati-course-cards-section .tick-icon {
            width: 24px;
            height: 24px;
            flex-shrink: 0;
            margin-top: 2px;
          }
          @media (max-width: 991px) {
            .naati-course-cards-section .naati-card {
              flex: 0 0 100%;
              max-width: 100%;
            }
            .naati-course-cards-section .card-wrapper {
              gap: 40px; /* More space between stacked cards */
            }
          }
        `}
      </style>
      <div className="custom-container">
        {skillAreaTitle && (
          <div className="d-block d-lg-flex justify-content-between align-items-center">
            <div>
            {skillAreaTitle()}
            </div>
            <div>
               {btnText &&  <ButtonComp link={btnLink} btnText={btnText}/>}
            </div>
          </div>
        )}

        <div className="card-wrapper">
          {cards.map((card, index) => (
            <div key={index} className={`naati-card ${card.isPopular ? 'popular' : ''}`}>
              {card.isPopular && (
                <div className="popular-badge">MOST POPULAR</div>
              )}
              <p className={`FS24FW500 fw-600  ${card.titleLarge ? 'large' : ''}`}>{card.title}</p>
              <ul className="feature-list-new">
                {card.features.map((feature, fIndex) => (
                    <li key={fIndex} className="feature-item-new">
                      <img src={Tick} alt="tick" className="tick-icon" />
                      <span>{feature}</span>
                    </li>
                ))}
              </ul>
                {card.bottomParagraph && card.bottomParagraph()}
                {(card.bottomBtnText && card.bottomBtnFunction) && (
                 <button
                      className={`card-btn plus-sans FS17FW500 to-unset-transform w-100 ${card.isPopular ? "primary-btn" : "cta-btn"}`}
                      onClick={card.bottomBtnFunction}
                    >
                      {card.bottomBtnText}{" "}
                      <img
                        src={`/images/web-new-images/${card.isPopular ? "right-arrow.svg" : "right-arrow-black.svg"}`}
                        alt="Register Now"
                      />
                  </button>
                )}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>  
  )
}

export default NaatiCourseCards;
